<script lang="ts">
    export let paragraphItems : any;
</script>

<p class="paragraph-item">
    {#each paragraphItems as item}
        {@html item.children[0].text}
    {/each}
</p>

<style lang="postcss">

    @import '../../styles/_mixins.css';

    .paragraph-item {
        @mixin paragraph;
        margin:0;
    }

</style>